import { isDefined } from '@sgme/fp';
import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedDate } from 'components/shared/Intl';
import { PresetDateReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';

export interface ProductSummaryPresetDateProps {
  node: PresetDateReadonlyValueDefinition;
}

export const ProductSummaryPresetDate: FC<ProductSummaryPresetDateProps> = ({ node }) => {
  const data = useReadonlyField().getMetadataWithData(node);

  const translationKey = node.translationKey ?? node.id;

  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      <p className="text-large fw-light m-0" data-e2e={`product-summary-field-${node.id}`}>
        {isDefined(data) && <FormattedDate value={data.date} year="numeric" month="short" day="2-digit" />}
      </p>
    </SummaryFieldRow>
  );
};
